import store from "@packages/store";
import Vue from "vue";
import VueRouter from "vue-router";
import auth from "../auth";
import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",

    routes: routes
});

router.beforeEach(async (to, _from, next) => {
    const token = auth.token();

    if(token && !store.state.users.user && !store.state.users.admin) {
        await auth.refetchLoginData();
    }

    if (to.meta.requiresAuth && !store.state.users.user) return next("/login");

    if (to.meta.requiresAdmin && !store.state.users.admin)
        return next("/login");

    next();
});

export default router;
